import { IconWrapper } from '../runtime';
export default IconWrapper('info-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + '46549828' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      "fill": "#0A6CFF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 13C8.55228 13 9 12.5523 9 12V7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7V12C7 12.5523 7.44772 13 8 13ZM7 4C7 4.55228 7.44772 5 8 5V5C8.55228 5 9 4.55228 9 4V4C9 3.44772 8.55228 3 8 3V3C7.44772 3 7 3.44772 7 4V4Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + '46549828'
    }
  }, [h("rect", {
    "attrs": {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
});